import { render } from "./AddModalValidationTask.vue?vue&type=template&id=391ae524&scoped=true&ts=true"
import script from "./AddModalValidationTask.vue?vue&type=script&lang=ts"
export * from "./AddModalValidationTask.vue?vue&type=script&lang=ts"

import "./AddModalValidationTask.vue?vue&type=style&index=0&id=391ae524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391ae524"]])

export default __exports__